// extracted by mini-css-extract-plugin
export var item = "styles_item__PsmEn";
export var mobileItems = "styles_mobileItems__HRgfk";
export var surprise = "styles_surprise__ZDPlP";